var confirmed = false;

function bindConfirmationBox() {
	$("body").on(ace.click_event, ".confirmation-box-link", function (e) {
		if (confirmed) {
			return true;
		}
		e.preventDefault();
		var self = this;

		bootbox.confirm({
			message: $(this).data('confirmation'),
			buttons: {
				'confirm': {
					label: $(this).data('confirmation-ok')
				},
				'cancel': {
					label: $(this).data('confirmation-cancel')
				}
			},
			callback: function (result) {
				if (result) {
					confirmed = true;
					$(self).click();
					window.location = $(self).attr('href');
				}
			}
		});
	});

	$("body").on(ace.click_event, ".confirmation-box-button", function (e) {
		if (confirmed) {
			return true;
		}
		e.preventDefault();
		var self = this;

		bootbox.confirm({
			message: $(this).data('confirmation'),
			buttons: {
				'confirm': {
					label: $(this).data('confirmation-ok')
				},
				'cancel': {
					label: $(this).data('confirmation-cancel')
				}
			},
			callback: function (result) {
				if (result) {
					confirmed = true;
					$(self).val('confirmed');
					$(self).click();
				}
			}
		});
	});
}

function bindTooltips() {
	$('[data-toggle="tooltip"]').tooltip({container: 'body'});
}

function bindPopovers() {
	$('[data-toggle="popover"]').popover();
}

$(function () {
	bindTooltips();
	bindPopovers();
	bindConfirmationBox();
});

function notify(message) {
	$.gritter.add({
		text: message,
		class_name: 'gritter-success',
		sticky: false
	});
}